import type { Product } from "@decocms/apps-commerce/types"
import { signal } from "~/sdk/signal"
import { SITE } from "~/constants"

export const MONTHLY_SKU_ID = "81043"
export const YEARLY_SKU_ID = "81044"
export const MONTHLY_PERIODICITY = "MONTHLY"
export const YEARLY_PERIODICITY = "YEARLY"
export const ACCOUNT_NAME = "miess"

const subscriptionSkus = signal([MONTHLY_SKU_ID, YEARLY_SKU_ID])

export const verifyIfSkuIsSubscription = (sku: string) =>
  subscriptionSkus.value.includes(sku)

export const getUserSubscription = async (
  email: string | null,
  cookie: string,
) => {
  if (!email) return null

  const response = await fetch(
    `https://${SITE.DOMAIN_BARE}/api/io/safedata/CL/search?email=${email}&_fields=isMiessPrime,periodicityMiessPrime`,
    {
      headers: {
        accept: "application/vnd.vtex.ds.v10+json",
        "content-type": "application/json",
        cookie,
      },
    },
  )
  const subscription = await response.json()

  return subscription[0] ?? null
}

/**
 * Server-side check: VTEX session cookies aren't available in commerce loaders
 * (framework only passes resolvedProps), so this returns false on the server.
 * The client can re-evaluate via the same logic once the user signal hydrates,
 * if/when we wire that up. For now the worst case is the monthly-subscription
 * button being enabled at first paint and disabled after server validation —
 * acceptable while the rest of the migration stabilizes.
 */
export const checkDisabledBuyMonthlySubscription = async (
  _products: Product[],
): Promise<boolean> => {
  return false
}

const state = {
  subscriptionSkus,
  verifyIfSkuIsSubscription,
}

export const useSubscription = () => state
